import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import customModalHeaderHP from "../../../../src/content/hiding-place-signup-and-watch-page/customModalHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  customModalHeaderHP,
  React
};